<template>
  <div v-if="$companyConfiguration.talentMatrix.isEnabled()">
    <page-heading heading="Матрицы талантов">
      <span slot="help"></span>
      <div slot="right">
        <div class="el-row--flex">
          <el-button
            v-if="$canAndRulesPass(user, 'talent_matrix.matrix_create')"
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="openEditDialog"
          >
            Добавить матрицу талантов
          </el-button>
        </div>
      </div>
    </page-heading>
    <el-card>
      <talent-matrices-component
        ref="talentMatricesComponent"
        :on-edit-matrix="openEditDialog"
      ></talent-matrices-component>
    </el-card>
    <talent-matrix-edit-dialog
      ref="editDialog"
      @matrix-saved="loadMatrices"
    >
    </talent-matrix-edit-dialog>
  </div>
</template>

<script>
import TalentMatrixEditDialog from "@/modules/talentMatrix/components/TalentMatrixEditDialog.vue";
import TalentMatricesComponent from "@/modules/talentMatrix/components/TalentMatricesComponent.vue";
import PageHeading from "@/components/PageHeading";
import {mapGetters} from "vuex";

export default {
  name: 'talent-matrices',
  components: {
    TalentMatrixEditDialog,
    TalentMatricesComponent,
    PageHeading,
  },
  computed:{
    ...mapGetters(['user'])
  },
  methods: {
    openEditDialog(matrix = {}) {
      this.$refs.editDialog.open(matrix);
    },
    loadMatrices() {
      if (this.$refs.talentMatricesComponent) {
        this.$refs.talentMatricesComponent.loadMatrices();
      }
    },
  }
}
</script>

<style scoped>

</style>